import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  OutlinedInput,
  IconButton,
} from '@mui/material';
import DownloadMenu from 'components/DownloadMenu/DownloadMenu';
import MDBox from 'components/MDBox';

import ClearIcon from '@mui/icons-material/Clear';

const MenuProps = {
  PaperProps: {
    style: {
      width: 250,
      maxHeight: 300,
      overflow: 'auto',
    },
  },
};

const durations = [
  {
    value: 7,
    label: 'Last 7 Days',
  },
  {
    value: 30,
    label: 'Last 30 Days',
  },
  {
    value: 365,
    label: 'Last Year',
  },
  // 'Last 5 Years',
];
const sorts = ['Recent', 'Highest to Lowest', 'Lowest to Highest'];
const states = [
  'Wisconsin',
  'Texas',
  'Florida',
  'Kentucky',
  'Washington',
  'Ohio',
];

const EXCLUDE_DURATION_FILTER = [
  'most-traded',
  'users-acquired',
  'users-by-age',
  'most-appreciated',
];

const ReportFilters = ({
  onChangeDuration,
  reportType,
  onDownloadCSV,
  onDownloadXLSX,
}) => {
  const [duration, setDuration] = useState('');
  const [state, setstate] = useState('');
  const [sort, setsort] = useState('');
  const handleDurationChange = (event) => {
    setDuration(event.target.value);
    onChangeDuration(event?.target?.value);
  };
  const handleSort = (event) => {
    setsort(event.target.value);
  };
  const handleStateChange = (event) => {
    setstate(event.target.value);
  };
  return (
    <MDBox mt={3}>
      <Grid container px={4} spacing={4}>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          {EXCLUDE_DURATION_FILTER.indexOf(reportType) === -1 && (
            <FormControl sx={{ minHeight: 48 }} fullWidth>
              <InputLabel id="duration-label">Duration</InputLabel>
              <Select
                labelId="duration-label"
                id="duration"
                value={duration}
                onChange={handleDurationChange}
                sx={{ minHeight: 48 }}
                input={<OutlinedInput label="Duration" />}
                MenuProps={MenuProps}
                endAdornment={
                  <IconButton
                    sx={{
                      visibility: duration ? 'visible' : 'hidden',
                      position: 'absolute',
                      right: '25px',
                      marginRight: '0',
                    }}
                    style={{
                      backgroundColor: 'white',
                    }}
                    onClick={() => {
                      setDuration('');
                      onChangeDuration(null);
                    }}
                    size="small"
                  >
                    <ClearIcon />
                  </IconButton>
                }
              >
                {durations.map((duration) => (
                  <MenuItem key={duration?.value} value={duration.value}>
                    {duration.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          {/* NOTE: commented for future use */}
          {/* <FormControl sx={{ minHeight: 48 }} fullWidth>
            <InputLabel id='sort-label'>Sort</InputLabel>
            <Select
              labelId='sort-label'
              value={sort}
              onChange={handleSort}
              id='sort'
              sx={{ minHeight: 48 }}
              input={<OutlinedInput label='Sort' />}
              MenuProps={MenuProps}>
              {sorts.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          {/* <FormControl sx={{ minHeight: 48 }} fullWidth>
            <InputLabel id="state-label">State</InputLabel>
            <Select
              labelId="state-label"
              id="state"
              value={state}
              onChange={handleStateChange}
              sx={{ minHeight: 48 }}
              input={<OutlinedInput label="State" />}
              MenuProps={MenuProps}
            >
              {states.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3} textAlign="right">
          {/* TODO: will take next time */}
          {/* <DownloadMenu
            onDownloadCSVClick={onDownloadCSV}
            onDownloadXLSXClick={onDownloadXLSX}
          /> */}
        </Grid>
      </Grid>
    </MDBox>
  );
};

ReportFilters.propTypes = {
  onChangeDuration: PropTypes.func,
  reportType: PropTypes.string,
  onDownloadCSV: PropTypes.func,
  onDownloadXLSX: PropTypes.func,
};

ReportFilters.defaultProps = {
  onChangeDuration: () => {},
  reportType: '',
  onDownloadCSV: () => {},
  onDownloadXLSX: () => {},
};

export default ReportFilters;
